import {
  Component, EventEmitter, Output, Input
} from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-drop-hints',
    templateUrl: './drop-hints.component.html',
    styleUrls: ['./drop-hints.component.scss'],
    standalone: false
})
export class DropHintsComponent {

  @Output() makeSuggestion: EventEmitter<string> = new EventEmitter<string>();

  @Input()
  set suggestions(suggestions: Array<string>) {
    this.longList = suggestions; this.update([], '');
  }

  public shortList: BehaviorSubject<string[]> = new BehaviorSubject([])
  public longList: string[] = [];
  public focusedIndex = -1;
  public trackMouse = false;

  update(exclusions: string[], startsWith: string) {
    const myShortList = this.longList.filter(x => !exclusions.includes(x) && x.startsWith(startsWith));
    this.shortList.next(myShortList.slice(0,5));
    this.focusedIndex = -1;
    this.trackMouse = false;
  }

  goDown() {
    if (!this.trackMouse) {
        this.focusedIndex = this.focusedIndex === this.shortList.getValue().length - 1
                            ? 0
                            : this.focusedIndex + 1;
    }
  }

  goUp() {
    if (!this.trackMouse) {
        this.focusedIndex = this.focusedIndex === 0
                            ? this.shortList.getValue().length - 1
                            : this.focusedIndex - 1;
    }
  }

  suggest() {
    if (this.focusedIndex > -1) {
      return this.shortList.getValue()[this.focusedIndex];
    }
  }

  onMouseEnter(i: number) {
    this.focusedIndex = i;
    this.trackMouse = true;
  }

  onMouseLeave() {
    this.focusedIndex = -1;
    this.trackMouse = false;
  }

  noFriends(): Observable<boolean> {
    return this.shortList.pipe(
      map(list => list.length === 0)
    );
  }
}
